import { Injectable, inject } from '@angular/core';
import Keycloak from 'keycloak-js';

@Injectable({ providedIn: 'root' })
export class KeycloakTokenRefresher {
  keycloak: Keycloak = inject(Keycloak);
  private intervalId: ReturnType<typeof setInterval> | null = null;

  constructor() {
    this.start();
  }

  start(refreshIntervalMs = 60_000, minValiditySec = 60): void {
    if (this.intervalId) {
      return;
    }
    this.intervalId = setInterval(() => {
      this.keycloak
        .updateToken(minValiditySec)
        .then((refreshed) => {
          if (refreshed) {
            console.debug('Keycloak token refreshed');
          }
        })
        .catch((err) => {
          console.warn('Keycloak token refresh failed', err);
        });
    }, refreshIntervalMs);

    window.addEventListener('beforeunload', () => this.stop());
  }

  stop(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
